// src/utils/validateTradeInput.js
import { normalizeItemName } from './normalizeItemName';

const ITEM_REGEX = /^(?:(\d+)x\s*)?([^()]+?)\s*\(\s*(\d+)(?:\s*-\s*(\d+))?\s*\)$/;

export function parseTradeInput(inputStr, validNamesSet) {
  const items = inputStr.split('+');
  const parsedItems = [];
  const errors = [];

  for (let rawItem of items) {
    rawItem = rawItem.trim();
    const match = rawItem.match(ITEM_REGEX);

    if (!match) {
      errors.push(`Invalid item format: '${rawItem}'`);
      continue;
    }

    const quantity = match[1] ? parseInt(match[1], 10) : 1;
    const nameRaw = match[2].trim();
    const name = normalizeItemName(nameRaw);
    const min = parseInt(match[3], 10);
    const max = match[4] ? parseInt(match[4], 10) : min;

    if (quantity <= 0 || min <= 0 || max <= 0 || min > max) {
      errors.push(`Invalid values in: '${rawItem}'`);
      continue;
    }
    if (!validNamesSet.has(name)) {
      errors.push(`Unknown item: '${nameRaw}'`);
      continue;
    }

    parsedItems.push({ name, quantity, min, max });
  }

  return { parsedItems, errors };
}
